import { Tooltip } from '@yuno/design-system-web'
import { AccountMenuItemNameProps, StyledName } from './account-menu.styled'
import AccountMenuTooltip from './account-menu-tooltip'
import { FC } from 'react'

export const AccountMenuItemName: FC<AccountMenuItemNameProps> = ({
  name,
  selectedAccount,
  profile,
}) => {
  if (name.length < 20) {
    return <StyledName>{name}</StyledName>
  }
  const accountName = `${name.substring(0, 20)}...`
  return (
    <Tooltip
      color={'black'}
      placement={'bottom-end'}
      title={<AccountMenuTooltip account={selectedAccount} profile={profile} />}
    >
      <StyledName>{accountName}</StyledName>
    </Tooltip>
  )
}
